import React from 'react'
import './Testimonial.css'
import Netflix from '../../assets/netflix.png'
import Meanbuy from '../../assets/meanbuy.png'
import Lovoda from '../../assets/lovoda.png'
import DotKey from '../../assets/dotandkey.png'
import Tictok from '../../assets/tictok.png'
import Youtube from '../../assets/youtube.png'


const Testimonial = () => {
  return (
    <section id='projects'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className="container portfolio_container">
        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={Netflix} alt="Netflix" />
    </div>
    <h3>Netflix Clone</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/i-am-Krishna/Netflix-clone"  target='_blank' className='btn'>Github</a>
    <a href="https://netflix-clone-6fbe7.web.app" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={Meanbuy} alt="Meanbuy" />
    </div>
    <h3>Meanbuy.com Clone</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/anandrajsingh05/MeanBuyProject"  target='_blank' className='btn'>Github</a>
    <a href="https://anandrajsingh05.github.io/MeanBuyProject" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={Lovoda} alt="Netflix" />
    </div>
    <h3>Lovoda.com Clone</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/i-am-Krishna/crazy-science-2420"  target='_blank' className='btn'>Github</a>
    <a href="https://lovoda-clone.vercel.app/" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={DotKey} alt="Netflix" />
    </div>
    <h3>Dot&Key.com Clone</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/rahulraka/Dot-and-Key-Skincare"  target='_blank' className='btn'>Github</a>
    <a href="https://dot-and-key.netlify.app/" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={Tictok} alt="Netflix" />
    </div>
    <h3>Tic Tok Toe Game</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/i-am-Krishna/Tic-Tac-Toe-game"  target='_blank' className='btn'>Github</a>
    <a href="https://calm-pithivier-182e39.netlify.app/" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        <article className='portfolio_item'>
    <div className='portfolio_item-image'>
<img src={Youtube} alt="Netflix" />
    </div>
    <h3>Youtube Clone</h3>
    <div className="portfolio_item-cta">

    <a href="https://github.com/i-am-Krishna/Youtube"  target='_blank' className='btn'>Github</a>
    <a href="https://krishnayoutube.netlify.app/" target='_blank' className='btn btn-primary' >Live Demo</a>
    </div>
        </article>

        </div>
    </section>
  )
}

export default Testimonial